import { render, staticRenderFns } from "./leftMenuItem.vue?vue&type=template&id=d393c2f0&scoped=true"
import script from "./leftMenuItem.vue?vue&type=script&lang=js"
export * from "./leftMenuItem.vue?vue&type=script&lang=js"
import style0 from "./leftMenuItem.vue?vue&type=style&index=0&id=d393c2f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d393c2f0",
  null
  
)

export default component.exports